// extracted by mini-css-extract-plugin
export default {"container":"TradeFairInformationContent_container__kdUii","action":"TradeFairInformationContent_action__c0WUx","actionText":"TradeFairInformationContent_actionText__-In7o"};